import React, { useEffect, useState } from "react";
import { Modal, InputNumber, Spin, message, Tag } from "antd";
import Alert from "../../components/GxAlert";
import { scGetWasteRules, scSetWasteRules } from "../../api/client";
import { useAuth } from "../../context/AuthContext";

const HINT = {
  knitting: "افتِ مجازِ تبدیلِ نخ به پارچهٔ خام (بافندگی).",
  dyeing: "افتِ مجازِ رنگرزی (پارچهٔ خام → رنگ‌شده).",
  transfer: "افتِ مجازِ جابه‌جایی/انتقال بین طرف‌ها.",
};

export default function ToleranceSettingsModal({ open, onClose, onSaved }) {
  const { can } = useAuth();
  const editable = can("sc.party.manage");
  const [rules, setRules] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setRules(null);
    scGetWasteRules().then((r) => setRules(r.data)).catch(() => message.error("خطا در بارگذاری تنظیمات"));
  }, [open]);

  const setVal = (pt, v) =>
    setRules((rs) => rs.map((r) => (r.process_type === pt ? { ...r, allowed_waste_percent: v, is_default: false } : r)));

  const save = async () => {
    setSaving(true);
    try {
      await scSetWasteRules(rules.map((r) => ({
        process_type: r.process_type, allowed_waste_percent: Number(r.allowed_waste_percent) || 0,
      })));
      message.success("آستانه‌های تلورانس ذخیره شد");
      onSaved && onSaved();
      onClose();
    } catch (e) { message.error(e?.response?.data?.detail || "خطا در ذخیره"); }
    setSaving(false);
  };

  return (
    <Modal title="تنظیماتِ تلورانس (آستانهٔ افتِ مجازِ هر مرحله)" open={open} onCancel={onClose}
      onOk={save} okText="ذخیره" cancelText="بستن"
      okButtonProps={{ loading: saving, disabled: !editable || !rules }} width={520}>
      <Alert type="info" showIcon style={{ marginBottom: 16 }}
        message="افتِ بیش از این درصد در هر مرحله، «بیش از تلورانس» (قرمز) نشان داده می‌شود."
        description={editable ? null : "فقط نقشِ مدیر/مدیریتِ طرف‌حساب‌ها می‌تواند این مقادیر را تغییر دهد."} />
      {!rules ? <Spin /> : (
        <div style={{ direction: "rtl" }}>
          {rules.map((r) => (
            <div key={r.process_type} style={{ display: "flex", alignItems: "center", justifyContent: "space-between",
              gap: 12, padding: "10px 0", borderBottom: "1px solid var(--border, #f0f0f0)" }}>
              <div>
                <b style={{ fontSize: 14 }}>{r.label}</b>
                {r.is_default && <Tag style={{ marginInlineStart: 8 }}>پیش‌فرض</Tag>}
                <div style={{ fontSize: 12, color: "#8c8c8c" }}>{HINT[r.process_type]}</div>
              </div>
              <InputNumber min={0} max={100} step={0.5} disabled={!editable}
                value={r.allowed_waste_percent} onChange={(v) => setVal(r.process_type, v)}
                addonAfter="٪" style={{ width: 130 }} />
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
